import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { preloadImages, isTouchDevice , debounce} from '../components/utils';


export function initTeam() {
    const teamMap = document.querySelector("#team-map");

    if (teamMap) {
        // Ensure there's a container for the images
        const scrollingContainer = teamMap.querySelector('.team-map__background');

        if (scrollingContainer) {
            const scrollingImage = scrollingContainer.querySelector('.team-map__scrolling-image');


            preloadImages().then(() => {

                // Clone and append the image for continuous scrolling
                const imageClone = scrollingImage.cloneNode(true);
                scrollingContainer.appendChild(imageClone); // Add clone to the container

                // Set up GSAP animation for continuous scrolling
                gsap.to(scrollingContainer, {
                    // Adjust duration to control the speed
                    duration: 30,
                    ease: "none",
                    x: () => `-${scrollingImage.offsetWidth}px`, // Move container to scroll images
                    repeat: -1,
                    modifiers: {
                        x: gsap.utils.unitize(x => parseFloat(x) % (scrollingImage.offsetWidth * 2)), // Loop back for seamless animation
                    },
                });


            });
        }


        function setupScrollTrigger() {
            // console.log('setupScrollTrigger');
            const teamMapHeight = teamMap.offsetHeight;
            const viewportHeight = window.innerHeight;

            // console.log('ScrollTrig');
            // console.log(teamMapHeight);
            // console.log(viewportHeight);

            // if (teamMapHeight < viewportHeight) {

                ScrollTrigger.create({
                    trigger: '#team-map',
                    start: 'top top', // Start pinning when the top of #team-map hits the top of the viewport
                    end: 'bottom bottom', // End pinning when the bottom of #team-map hits the top of the viewport
                    pin: '.team-map__background', // Element to pin
                    pinSpacing: false, // Set to true if you want to keep the natural document flow
                });
            // }
        }

        preloadImages().then(() => {
            // console.log("Images have been preloaded.");
            setupScrollTrigger();
        });




        // Select all team member inner elements
        const teamMembers = document.querySelectorAll(".team-map__member-inner");

        if (!isTouchDevice()) {


            const teamMembers = document.querySelectorAll(".team-map__member-inner");

            teamMembers.forEach(member => {
                const tease = member.querySelector('.team-map__member-tease');

                // Mouse enter: Add 'hovered' to current tease and remove from others
                tease.addEventListener('mouseenter', () => {
                    // Remove 'hovered' class from all teases except the current one
                    document.querySelectorAll('.team-map__member-tease').forEach(el => {
                        if (el !== tease) {
                            el.classList.remove('hovered');
                            // Optionally reset GSAP animation here for all except the current one
                            gsap.to(el, {
                                scale: 0.8,
                                opacity: 0,
                                duration: 0.15,
                                ease: 'power3.out'
                            });
                        }
                    });

                    // Add 'hovered' class to the current tease
                    tease.classList.add('hovered');
                    // Animate in for the current tease
                    gsap.to(tease, {
                        scale: 1,
                        opacity: 1,
                        duration: 0.2,
                        ease: 'power3.out'
                    });
                });

                // Mouse leave: Remove 'hovered' class from the current tease
                tease.addEventListener('mouseleave', () => {
                    tease.classList.remove('hovered');
                    // Animate out for the current tease
                    gsap.to(tease, {
                        scale: 0.8,
                        opacity: 0,
                        duration: 0.15,
                        ease: 'power3.out'
                    });
                });
            });

        }


        const pagebody = document.querySelector('body');

        // Event listener for opening card
        document.querySelectorAll(".team-map__member-tease").forEach(tease => {
            tease.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const memberCard = tease.closest('.team-map__member').querySelector('.team-map__member-card');
                const wrapper = memberCard.closest('.team-map__member-card-wrapper'); // Get the wrapper
                memberCard.classList.add('active');
                pagebody.classList.add('no-scroll');
                wrapper.classList.add('active'); // Add 'active' class to the wrapper
                activateCard(memberCard);
            });
        });

        // Event listener for closing card (close button)
        document.querySelectorAll('.team-map__member-card-inner .close-button').forEach(button => {
            button.addEventListener('click', (event) => {
                event.stopPropagation();
                const memberCard = button.closest('.team-map__member-card');
                const wrapper = memberCard.closest('.team-map__member-card-wrapper'); // Get the wrapper
                memberCard.classList.remove('active');
                pagebody.classList.remove('no-scroll');
                wrapper.classList.remove('active'); // Remove 'active' class from the wrapper
                deactivateCard(memberCard);
            });
        });

        // Click outside to close card
        document.addEventListener('click', (event) => {
            if (!event.target.closest('.team-map__member-card') && !event.target.closest('.team-map__member-tease')) {
                document.querySelectorAll('.team-map__member-card.active').forEach(memberCard => {
                    const wrapper = memberCard.closest('.team-map__member-card-wrapper'); // Get the wrapper
                    memberCard.classList.remove('active');
                    pagebody.classList.remove('no-scroll');
                    wrapper.classList.remove('active'); // Remove 'active' class from the wrapper
                    deactivateCard(memberCard);
                });
            }
        });

        function activateCard(memberCard) {
            gsap.set(memberCard, { scaleY: 0, autoAlpha: 0, });
            gsap.to(memberCard, {
                scaleY: 1,
                autoAlpha: 1,
                duration: 0.2,
                ease: 'power3.out',
                onComplete: () => {
                    gsap.to(memberCard.querySelector('.team-map__member-card-inner'), {
                        autoAlpha: 1,
                        duration: 0.15,
                        ease: 'power3.inOut'
                    });
                }
            });
        }

        function deactivateCard(memberCard) {
            gsap.to(memberCard.querySelector('.team-map__member-card-inner'), {
                autoAlpha: 0,
                duration: 0.1,
                ease: 'power3.inOut'
            });
            gsap.to(memberCard, {
                scaleY: 0,
                autoAlpha: 0,
                delay: 0.1,
                duration: 0.15,
                ease: 'power3.out'
            });
        }

        var event = new Event('resize');

        function handleMoreTeamClick() {
            window.dispatchEvent(event);
            adjustBackgroundHeight();

        }



        function adjustBackgroundHeight() {
            const teamMapBackground = document.querySelector('.team-map__background');
            const teamMap = document.querySelector('#team-map .team-map__wrapper');

            if (teamMapBackground && teamMap) {
                const viewportHeight = window.innerHeight;
                const teamMapHeight = teamMap.offsetHeight;
                const finalHeight = Math.min(viewportHeight, teamMapHeight);
                teamMapBackground.style.height = `${finalHeight}px`;
            }

        };

        // Initial call to set the background height
        adjustBackgroundHeight();


        const moreTeamElement = document.querySelector('#more-team');
        if (moreTeamElement) {
            moreTeamElement.addEventListener('click', handleMoreTeamClick);
        }



        // Debounced version of adjustBackgroundHeight to use on window resize
        const debouncedAdjustBackgroundHeight = debounce(adjustBackgroundHeight, 250);

        window.addEventListener('resize', debouncedAdjustBackgroundHeight);


//
//
//         function adjustBackgroundHeight() {
//             // Get the elements
//             const teamMapBackground = document.querySelector('.team-map__background');
//             const teamMap = document.querySelector('#team-map .team-map__wrapper');
//
//             if (teamMapBackground && teamMap) {
//                 // Get the heights
//                 const viewportHeight = window.innerHeight;
//                 const teamMapHeight = teamMap.offsetHeight;
//
//                 // Determine the height to use
//                 const finalHeight = Math.min(viewportHeight, teamMapHeight);
//
//                 // Set the height of .team-map__background
//                 teamMapBackground.style.height = `${finalHeight}px`;
//             }
//         }
//
//         // Call the function on page load
//         adjustBackgroundHeight();
//
//         // Optionally, adjust on window resize
//         window.addEventListener('resize', adjustBackgroundHeight);


    }

}
